export default __webpack_public_path__ + "static/media/office1-after1-768w.415f8c7a.webp";